import {Injectable} from '@angular/core';
import {CompanyType} from "../../enums/company-type";

@Injectable({
  providedIn: 'root'
})
export class ModelService {

  constructor() {
  }

  getModelLabel(model: any, identifier: string) {
    switch (identifier) {
      case 'customers':
        return model.companyType == CompanyType.COMPANY ? model.company : model.person.name;
      case 'api-interfaces':
        return model.name ?? model.username;
      case 'addresses':
        return `${model.street} ${model.houseNumber}, ${model.postcode} ${model.place}`;
    }

    return '';
  }
}
